"use strict";

module.exports = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/q.js
// module id = 220
// module chunks = 0